import '../styles/home-styles.css';
import "../extensions/leaflet-search/leaflet-search.min.js";
import "../extensions/leaflet-search/leaflet-search.min.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.markercluster";

import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/regular';
import BaseLeaf from "@/my-leaf/base/base-leaf";
import { eventBus } from '@/main';

// import { AIOLayer } from '@/my-leaf/layers/aio-layer';
import { NavareaLayer } from '@/my-leaf/layers/navarea-layer';
import { PortsLayer } from '@/my-leaf/layers/ports-layer';
import { ShipsLayer } from '@/my-leaf/layers/ships-layer';

export class HomeLeaf extends BaseLeaf {
    constructor(elementId, options = {}) {
        const homeLeafOptions = {
            ...options,
            preferCanvas: false // Запрещаем использование Canvas для совместимости с несколькими слоями
        };

        super(elementId, homeLeafOptions);
        this.enabledLayers = [];

        // Слои карты, инициализируем позже
        // this.aioLayer = null;
        this.navareaLayer = null;
        this.shipsLayer = null;
        this.portsLayer = null;
    }

    // Инициализация карты и базового класса
    async init(el, tiles) {
        super.init(el, tiles);
    
        if (!this.map) {
            console.error("Failed to initialize map");
            return Promise.reject();
        }
        return;        
    }    
    
    // Инициализация слоев карты
    async initLayers() {
        if (!this.map) return Promise.reject();

        // Инициализируем слои
        this.shipsLayer = new ShipsLayer(this.map, this.layerControl);
        this.shipsLayer.addShipLayer();

        this.portsLayer = new PortsLayer(this.map, this.layerControl);
        this.portsLayer.addPortsLayer();

        // this.aioLayer = new AIOLayer(this.map, this.layerControl);
        // this.aioLayer.addAIOLayer()

        this.navareaLayer = new NavareaLayer(this.map, this.layerControl);
        this.navareaLayer.addNavareaLayer()

        return
    }

    // Отрисовка кораблей
    drawShips(ships, selectedShipId = null, props = null) {
            if (!this.shipsLayer) {
            console.warn("ShipsLayer not initialized yet, skipping drawShips");
            return;
        }
        
        return this.shipsLayer.drawShips(ships, selectedShipId, props);
    }    

    // Центровка по выбранному кораблю и отображение попапа
    setSelectedShip(deviceId, zoom = 8) {
        if (!this.shipsLayer) {
            console.warn("ShipsLayer not initialized yet, skipping setSelectedShip");
            return;
        }
        
        return this.shipsLayer.setSelectedShip(deviceId, zoom);
    } 
    
    // Отключаем все overlay слои в layerControl
    disableAllOverlays() {
        if (!this.layerControl) return;

        // Получаем все overlay слои из layerControl
        const overlays = this.layerControl._layers;
        
        for (let layerId in overlays) {
            const layerObj = overlays[layerId];
            
            // Проверяем, что это overlay слой (не base layer)
            if (layerObj.overlay && this.map.hasLayer(layerObj.layer)) {
                // Отключаем слой с карты
                this.map.removeLayer(layerObj.layer);
            }
        }
    }

    // Очищаем все слои
    destroy() {
        try {
            // Отключаем все event listeners сначала
            // if (typeof eventBus !== 'undefined' && eventBus) {
            //     eventBus.$off('close-aio-popup');
            //     eventBus.$off('highlight-aio-on-map');
            //     eventBus.$off('clear-aio-highlight');
            // }

            // Очищаем все слои с детальной очисткой
            // if (this.aioLayer) {
            //     this.aioLayer.destroy();
            //     this.aioLayer = null;
            // }

            if (this.navareaLayer) {
                this.navareaLayer.destroy();
                this.navareaLayer = null;
            }

            if (this.portsLayer) {
                this.portsLayer.destroy();
                this.portsLayer = null;
            }

            if (this.shipsLayer) {
                this.shipsLayer.destroy();
                this.shipsLayer = null;
            }

            // Очищаем массив включенных слоев
            if (this.enabledLayers) {
                this.enabledLayers.length = 0;
                this.enabledLayers = null;
            }

            // Вызываем родительский destroy
            super.destroy();
            
        } catch (error) {
            console.warn('Ошибка при очистке HomeLeaf:', error);
            
            // В случае ошибки все равно обнуляем ссылки
            // this.aioLayer = null;
            this.navareaLayer = null;
            this.portsLayer = null;
            this.shipsLayer = null;
            this.enabledLayers = null;
            
            // Все равно вызываем родительский destroy
            super.destroy();
        }
    }
}
